import { memo } from 'react';

const DAY_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export const DaysPill = memo(function DaysPill({ days }: { days: number[] }) {
  const activeSet = new Set(days);
  return (
    <div className="flex gap-0.5">
      {DAY_LABELS.map((label, idx) => (
        <span
          key={idx}
          className={`inline-flex h-6 w-7 items-center justify-center rounded text-[9px] font-bold ${
            activeSet.has(idx)
              ? 'bg-violet-500 text-white'
              : 'bg-neutral-100 text-neutral-400 dark:bg-neutral-700/60 dark:text-neutral-500'
          }`}
        >
          {label.charAt(0)}
        </span>
      ))}
    </div>
  );
});
